import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { ButtonComponent } from './ButtonComponent';
import clsx from 'clsx';

interface Props {
  name: string;
  additionalClass?: string;
}

export const DropdownDisabledPlaceholder: FC<Props> = (props) => {
  const { name, additionalClass } = props;

  return (
    <ButtonComponent
      additionalClass={clsx('py-3 px-3 fs-7', additionalClass)}
      isDisabled
    >
      <div className="d-flex align-items-center justify-content-between">
        {name}
        <FontAwesomeIcon
          icon={faAngleDown}
          width={12}
          className="mt-1 ms-5"
        />
      </div>
    </ButtonComponent>
  );
};